import React from 'react'
import { MaskedProperty, Property } from '../../../../types/Property/Property'
import { classNames } from '../../../../lib/utils/classNames'
import { formatCurrency } from '../../../../lib/utils/formatNumber'
import ProgressBar from '../../ProgressBar'
import { useTranslation } from 'next-i18next'
import ContributorsCount from './ContributorsCount'
import useCurrency from '../../../../hooks/useCurrency'
import useLocale from '../../../../hooks/useLocale'

type FinancingAdvancementCardProps = {
  className?: string
  property: Property | MaskedProperty
}

export default function FinancingAdvancementCard({
  property,
  className = '',
}: FinancingAdvancementCardProps) {
  const { t } = useTranslation('originals/property')
  const { currency } = useCurrency()
  const { locale } = useLocale()

  return (
    <div className={classNames(className, 'rounded-2xl bg-neutralWhite p-2.5')}>
      <div className="mb-1 font-bold text-neutralBlack">
        {t('financeAdvancementCard.title')}
      </div>

      <div>
        <div className="text-center text-sm font-light text-neutralBlack">
          <strong className="text-base font-bold">
            {formatCurrency(
              property.fractionFunded * 10 * 100,
              0,
              2,
              currency,
              locale,
            )}
          </strong>
          {' / '}
          {formatCurrency(
            property.fractionCount * 10 * 100,
            0,
            2,
            currency,
            locale,
          )}
        </div>

        <ProgressBar
          fractionCount={property.fractionCount}
          fractionFunded={property.fractionFunded}
          id={property.id}
          lineHeight={2}
        />
      </div>

      <ContributorsCount property={property} />
    </div>
  )
}
